(function () {
  function neutralizeForeignSellingPlanInputs(productForm) {
    var all = document.querySelectorAll('input[name="selling_plan"]');
    all.forEach(function (el) {
      if (el.hasAttribute('data-nc-selling-plan-input')) return;
      el.setAttribute('data-nc-original-name', 'selling_plan');
      el.removeAttribute('name');
      el.disabled = true;
    });
  }

  function init(productForm) {
    if (productForm.dataset.ncSubscriptionInit === 'true') return;
    productForm.dataset.ncSubscriptionInit = 'true';

    neutralizeForeignSellingPlanInputs(productForm);
    var appstleObserver = new MutationObserver(function () {
      neutralizeForeignSellingPlanInputs(productForm);
    });
    appstleObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['name'] });

    var formEl = productForm.querySelector('form');
    if (formEl) {
      formEl.addEventListener('submit', function () {
        neutralizeForeignSellingPlanInputs(productForm);
      }, true);
    }

    function getInput() {
      return productForm.querySelector('[data-nc-selling-plan-input]');
    }
    function getQuantityInput() {
      return productForm.querySelector('[data-nc-quantity]');
    }
    function getPackPropertyInput() {
      return productForm.querySelector('[data-nc-pack-property]');
    }
    function getVariantIdInput() {
      var form = productForm.querySelector('form');
      return form ? form.querySelector('input[name="id"]') : null;
    }
    function getFrequencySelect() {
      return productForm.querySelector('[data-nc-frequency-select]');
    }
    function getBundleVariantId() {
      // Capture once on first call so we don't lose the original after a subscribe-toggle.
      if (!productForm.dataset.ncBundleVariantId) {
        var input = getVariantIdInput();
        if (input) productForm.dataset.ncBundleVariantId = input.value;
      }
      return productForm.dataset.ncBundleVariantId || '';
    }
    function getRadios() {
      return productForm.querySelectorAll('[data-nc-purchase-radio]');
    }

    function getSelectedPlanId() {
      var select = getFrequencySelect();
      if (select && select.options[select.selectedIndex]) {
        return select.options[select.selectedIndex].value;
      }
      return productForm.dataset.ncSellingPlanId || '';
    }

    function applySelection() {
      // Capture bundle variant ID before any rewrite happens.
      getBundleVariantId();

      var checked = productForm.querySelector('[data-nc-purchase-radio]:checked');
      var isSubscribe = checked && checked.value === 'subscribe';

      var sellingPlanInput = getInput();
      var quantityInput = getQuantityInput();
      var packPropInput = getPackPropertyInput();
      var variantIdInput = getVariantIdInput();
      var packSize = parseInt(productForm.dataset.ncPackSize || '1', 10) || 1;
      var singleVariantId = productForm.dataset.ncSingleVariantId || '';
      var bundleVariantId = getBundleVariantId();
      var packLabel = packSize + '-Pack subscription';

      if (isSubscribe && singleVariantId) {
        if (variantIdInput) variantIdInput.value = singleVariantId;
        if (quantityInput) quantityInput.value = String(packSize);
        if (sellingPlanInput) sellingPlanInput.value = getSelectedPlanId();
        if (packPropInput) packPropInput.value = packLabel;
      } else {
        if (variantIdInput) variantIdInput.value = bundleVariantId;
        if (quantityInput) quantityInput.value = '1';
        if (sellingPlanInput) sellingPlanInput.value = '';
        if (packPropInput) packPropInput.value = '';
      }
    }

    function restoreSelection() {
      var desired = productForm.dataset.ncDesiredPurchase || 'one_time';
      var target = productForm.querySelector('[data-nc-purchase-radio][value="' + desired + '"]');
      if (target && !target.disabled) {
        target.checked = true;
      } else {
        var oneTime = productForm.querySelector('[data-nc-purchase-radio][value="one_time"]');
        if (oneTime) oneTime.checked = true;
        productForm.dataset.ncDesiredPurchase = 'one_time';
      }
      applySelection();
    }

    productForm.addEventListener('change', function (e) {
      if (!e.target || !e.target.matches) return;
      if (e.target.matches('[data-nc-purchase-radio]')) {
        productForm.dataset.ncDesiredPurchase = e.target.value;
        applySelection();
      } else if (e.target.matches('[data-nc-frequency-select]')) {
        applySelection();
      }
    });

    productForm.addEventListener('click', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-nc-purchase-radio]')) {
        productForm.dataset.ncDesiredPurchase = e.target.value;
        applySelection();
      }
    });

    restoreSelection();

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var sectionId = productForm.closest('[data-section]')?.dataset.section;
      if (sectionId && event.data.sectionId !== sectionId) return;

      var newDoc = event.data.html;
      var newProductForm = newDoc.querySelector('product-form[data-nc-selling-plan-id]');
      var newOptions = newDoc.querySelector('[data-nc-purchase-options]');
      if (!newOptions) return;

      if (newProductForm) {
        productForm.dataset.ncSellingPlanId = newProductForm.dataset.ncSellingPlanId || '';
        productForm.dataset.ncPackSize = newProductForm.dataset.ncPackSize || '1';
        productForm.dataset.ncSingleVariantId = newProductForm.dataset.ncSingleVariantId || '';
      }
      // Refresh captured bundle variant id from the new section render so subsequent
      // toggles back to one-time use the new variant.
      var newVariantInput = newDoc.querySelector('input[name="id"]');
      if (newVariantInput) productForm.dataset.ncBundleVariantId = newVariantInput.value;

      function swap(selector) {
        var src = newOptions.querySelector(selector);
        var dst = productForm.querySelector(selector);
        if (src && dst) dst.innerHTML = src.innerHTML;
      }
      swap('[data-nc-price-onetime]');
      swap('[data-nc-price-subscribe]');
      swap('[data-nc-savings-badge]');

      // Swap the frequency dropdown wholesale (different pack size = different plan group).
      var newFreq = newDoc.querySelector('[data-nc-frequency]');
      var currentFreq = productForm.querySelector('[data-nc-frequency]');
      if (newFreq && currentFreq) {
        currentFreq.innerHTML = newFreq.innerHTML;
      } else if (newFreq && !currentFreq) {
        // Frequency wrapper didn't exist (e.g. previous variant had no plans); inject it.
        var sellingPlanInput = productForm.querySelector('[data-nc-selling-plan-input]');
        if (sellingPlanInput) sellingPlanInput.parentNode.insertBefore(newFreq.cloneNode(true), sellingPlanInput);
      } else if (!newFreq && currentFreq) {
        currentFreq.remove();
      }

      var newSubscribeRadio = newOptions.querySelector('[data-nc-option="subscribe"] [data-nc-purchase-radio]');
      var subscribeRadio = productForm.querySelector('[data-nc-option="subscribe"] [data-nc-purchase-radio]');
      var subscribeLabel = productForm.querySelector('[data-nc-option="subscribe"]');
      if (newSubscribeRadio && subscribeRadio && subscribeLabel) {
        var isDisabled = newSubscribeRadio.disabled;
        subscribeRadio.disabled = isDisabled;
        subscribeLabel.classList.toggle('is-disabled', isDisabled);
      }

      restoreSelection();
    });
  }

  function initDialog(productForm) {
    var trigger = productForm.querySelector('[data-nc-subscription-info-trigger]');
    var dialog = productForm.querySelector('[data-nc-subscription-info-dialog]');
    var closeBtn = productForm.querySelector('[data-nc-subscription-info-close]');
    if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      dialog.showModal();
    });

    closeBtn?.addEventListener('click', function () {
      dialog.close();
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
  }

  function hideAppstleDisclaimer(root) {
    var DISCLAIMER_NEEDLE = 'deferred, subscription, or recurring';
    var nodes = root.querySelectorAll('p, span, div, small');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest('.nc-subscription-dialog')) continue;
      if (el.children.length === 0 && el.textContent.indexOf(DISCLAIMER_NEEDLE) !== -1) {
        var target = el.closest('p, div, small') || el;
        target.classList.add('nc-appstle-hidden');
      }
    }
  }

  function watchAppstleDisclaimer(productForm) {
    var root = productForm.closest('product-info') || document.body;
    hideAppstleDisclaimer(root);
    var observer = new MutationObserver(function () {
      hideAppstleDisclaimer(root);
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function initAll() {
    document.querySelectorAll('product-form[data-nc-selling-plan-id]').forEach(function (pf) {
      init(pf);
      initDialog(pf);
      watchAppstleDisclaimer(pf);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // The quick-add modal (sections/featured-collection.liquid + assets/quick-add.js)
  // injects a fresh <product-info> + <product-form> into the DOM after page load.
  // Re-run initAll on these dynamic injection paths. init() is idempotent (guarded
  // by data-nc-subscription-init), so re-running is safe.
  //
  // Two triggers because Shopify's product-info:loaded event fires from
  // connectedCallback (most reliable), but we also keep a MutationObserver as a
  // fallback in case some flow injects a product-form without a product-info wrapper.
  document.addEventListener('product-info:loaded', initAll);

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        var isForm = node.matches && node.matches('product-form[data-nc-selling-plan-id]');
        var hasForm = node.querySelector && node.querySelector('product-form[data-nc-selling-plan-id]');
        if (isForm || hasForm) {
          initAll();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
